module.exports = __webpack_public_path__ + "static/media/Target2015-CSR-cover.dd93f538.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Target2015-CSR-cover.png
// module id = 943
// module chunks = 0